export default {"src":"/_next/static/media/fullScreenIcon.3e5a1928.svg","height":34,"width":34};